// =====================================================================
// excelFormulas.js
// Réplica exacta de las funciones de Excel usadas en Cotizador_VV170326
// =====================================================================

/**
 * Excel MROUND: redondea al múltiplo más cercano.
 * MROUND(x, 1000) => redondea a miles.
 */
export function mround(valor, multiplo = 1000) {
  if (!multiplo) return valor
  return Math.round(valor / multiplo) * multiplo
}

/**
 * Excel PROPER: primera letra de cada palabra en mayúscula.
 */
export function proper(texto = "") {
  return String(texto)
    .toLowerCase()
    .replace(/(^|\s|[-/(])\p{L}/gu, m => m.toUpperCase())
}

/**
 * Excel DOLLAR(x, 0) tal como se ve en el Excel de la agencia:
 * "$8.261.000" (formato COP sin decimales).
 */
export function dollar(valor, decimales = 0) {
  if (!Number.isFinite(valor)) return String(valor)
  return "$" + new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  }).format(valor)
}

const MESES_LARGO = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
]

const MESES_CORTO = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic"
]

/**
 * Parseo seguro de "yyyy-MM-dd" a Date local (sin desfase UTC).
 */
export function parseFecha(fecha) {
  if (fecha instanceof Date) return fecha
  if (!fecha) return null
  const [y, m, d] = String(fecha).split("-").map(Number)
  return new Date(y, m - 1, d)
}

/**
 * Diferencia en días (Excel: fecha2 - fecha1).
 */
export function diffDias(inicio, fin) {
  const a = parseFecha(inicio)
  const b = parseFecha(fin)
  if (!a || !b) return NaN
  return Math.round((b - a) / 86400000)
}

/**
 * Suma días a una fecha (Excel: fecha + n).
 */
export function sumarDias(fecha, dias) {
  const f = parseFecha(fecha)
  const r = new Date(f)
  r.setDate(r.getDate() + dias)
  return r
}

function dd(fecha) {
  return String(parseFecha(fecha).getDate()).padStart(2, "0")
}

/**
 * Réplica de la fórmula de rango de fechas del Excel:
 *
 * =PROPER(IF(MONTH(ini)=MONTH(fin),
 *   CONCATENATE("DEL ",TEXT(ini,"dd")," AL ",TEXT(fin,"dd")," DE ",TEXT(fin,"mmmm")),
 *   CONCATENATE("DEL ",TEXT(ini,"dd mmm")," AL ",TEXT(fin,"dd mmm"))))
 *
 * Mismo mes:      "Del 05 Al 10 De Enero"
 * Meses distintos: "Del 28 Ene Al 04 Feb"
 */
export function rangoFechas(inicio, fin) {
  const a = parseFecha(inicio)
  const b = parseFecha(fin)
  if (!a || !b) return ""

  if (a.getMonth() === b.getMonth()) {
    return proper(`DEL ${dd(a)} AL ${dd(b)} DE ${MESES_LARGO[b.getMonth()]}`)
  }

  return proper(
    `DEL ${dd(a)} ${MESES_CORTO[a.getMonth()]} AL ${dd(b)} ${MESES_CORTO[b.getMonth()]}`
  )
}

/**
 * Excel ISODD.
 */
export function isOdd(n) {
  return Math.abs(n % 2) === 1
}

export const REVISE_FECHAS = "REVISE LAS FECHAS"

/**
 * Envuelve un cálculo con la validación estándar del Excel:
 * =IF((fin-inicio)<0,"REVISE LAS FECHAS", calculo)
 */
export function conValidacionFechas(inicio, fin, calculo) {
  const d = diffDias(inicio, fin)
  if (!Number.isFinite(d)) return null
  if (d < 0) return REVISE_FECHAS
  return calculo(d)
}
